// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scrollNote[data-v-ec0fc49e] {\n  max-height: 100px;\n  overflow: auto;\n}[dir] .scrollNote[data-v-ec0fc49e] {\n  border: 1px solid rgb(190, 190, 190);\n  border-radius: 5px;\n  padding: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
